<template>
  <landing-home :landing="landing as Landing" />
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from "vue";
import { useRouter } from "vue-router";
import { useLandingStore } from "@/store/landing";
import LandingHome from "@/components/v2/landing-home/index.vue";
import { Landing } from "@/interfaces/Landing.ts";

defineOptions({
  name: "landing",
});

const props = defineProps({
  id: {
    type: Number,
    required: true,
  },
});

const landingStore = useLandingStore();
const router = useRouter();
const landing = ref<Landing | null>(null);

onBeforeMount(async () => {
  try {
    landing.value = landingStore.getLandingPageById(props.id);

    if (!landing.value) {
      landing.value = await landingStore.fetchLandingPage({ id: props.id });
    }
  } catch {
    await router.push("/tourpage");
  }
});
</script>
